'use strict';

var Consts = require('consts');
var Shared = require('shared_data.generated');

var unitBaseCache = {};
var relatedByBase = {};

var cloneAsJSON = function (obj) {
    if (!obj) return undefined;
    return JSON.parse(JSON.stringify(obj));
};

var selectWhere = function (src, cond, mapFct) {
    var r = _.filter(src, cond);
    if (mapFct) {
        r = _.map(r, mapFct);
    }
    return r;
};

var selectByPriority = function (selected) {
    var available = Consts.Backend.Units.available;
    for (var i = 0; i < available.length; i++) {
        for (var j = 0; j < selected.length; j++) {
            if (available[i].indexOf(selected[j]) >= 0) return selected[j];
        }
    }

    _.sortBy(selected, function (a) {
        return a;
    });
    return selected[0];
};

var getBaseUnits = function (unit) {
    var result = [];
    findUnit(result, { k: 1 }, unit);
    return result;
};

var hasPrefix = function (ms, ss) {
    return ms.startsWith(ss);
};

var findUnit = function (result, src, unit) {
    // no unit? no unit then.
    if (unit === undefined) return '';

    // nothing left? we're done
    if (!unit.length) {
        if (src.units && src.units.length > 0) {
            result.push(cloneAsJSON(src));
        }
        return;
    }

    if (hasPrefix(unit, ' ')) {
        findUnit(result, src, unit.substr(unit.indexOf(' ') + 1));
        return;
    }

    if (hasPrefix(unit, '/')) {
        // nothing yet? the unit is invalid
        if (src.units == undefined || !src.units.length) {
            return;
        }

        var r = [];
        findUnit(r, { k: 1 }, unit.substr(unit.indexOf('/') + 1));

        _.each(r, function (den) {
            if (den.k) {
                result.push(combine(src, den, true));
            }
        });
        return;
    }

    var cnt = result.length;
    _.each(Consts.Backend.Units.prefix, function (k, p) {
        if (hasPrefix(unit, p)) {
            findUnitPrefix(result, src, unit.substr(p.length), p, k);
        }
    });

    if (result.length != cnt) {
        return;
    }

    findUnitPrefix(result, src, unit, '', 1);
};

var findUnitPrefix = function (result, prev, unit, prefix, k) {
    _.each(Consts.Backend.Units.units, function (info, u) {
        if (!hasPrefix(unit, u)) return;
        var restUnit = unit.substr(u.length);
        if (!info.related) {
            var ex = 1;
            _.each(Consts.Backend.Units.exponentiation, function (exp, exs) {
                if (hasPrefix(restUnit, exs)) {
                    ex = exp;
                    restUnit = restUnit.substr(exs.length);
                }
            });

            var newRec = {
                k: Math.pow(k, ex),
                units: [u],
                base: {},
            };
            newRec.base[u] = ex;
            newRec = combine(prev, newRec, false);
            findUnit(result, newRec, restUnit);
        } else {
            var rlist = [];
            findUnit(rlist, { k: 1 }, info.related);
            _.each(rlist, function (r) {
                if (r.units.length) {
                    var newRec = combine(prev, r, false);
                    newRec.k = newRec.k * k * info.related_k;
                    findUnit(result, newRec, restUnit);
                }
            });
        }
    });
};

var combine = function (r1, r2, isDiv) {
    var newObj = {
        k: isDiv ? r1.k / r2.k : r1.k * r2.k,
        base: {},
        units: [],
    };

    _.each(r1.units, function (u) {
        if (newObj.base[u] === undefined) {
            newObj.units.push(u);
        }
        newObj.base[u] = r1.base[u];
    });
    _.each(r2.units, function (u) {
        if (newObj.base[u] === undefined) {
            newObj.units.push(u);
        }
        newObj.base[u] = (newObj.base[u] || 0) + (isDiv ? -r2.base[u] : r2.base[u]);
    });
    return newObj;
};

var matchUnitRecalc = function (r1, r2) {
    var isEqual = true;

    _.each(r1.base, function (v, k) {
        isEqual = isEqual && r2.base[k] == v;
    });
    _.each(r2.base, function (v, k) {
        isEqual = isEqual && r1.base[k] == v;
    });

    return isEqual;
};

var getBaseUnitStrOf = function (r) {
    return _.sortBy(
        selectWhere(
            r.units,
            function (x) {
                return r.base[x] != 0;
            },
            function (x) {
                return '' + x + r.base[x];
            }
        ),
        function (x) {
            return x;
        }
    ).join(' ');
};

var getBaseUnitsStr = function (unit) {
    if (unitBaseCache[unit] === undefined) {
        var r = getBaseUnits(unit);
        if (r.length == 1 && r[0].units.length > 0) {
            unitBaseCache[unit] = getBaseUnitStrOf(r[0]);
        }
    }
    return unitBaseCache[unit];
};

var buidRelatedMap = function () {
    if (_.keys(relatedByBase).length) {
        return;
    }

    _.each(Consts.Backend.Units.units, function (info, unit) {
        var b = getBaseUnitsStr(unit);
        if (!b.length || info.hidden) return;

        relatedByBase[b] = relatedByBase[b] || [];
        relatedByBase[b].push(unit);
        var prefixArray = info.output_prefix || info.prefix;
        _.each(prefixArray, function (pref) {
            relatedByBase[b].push('' + pref + unit);
        });
    });

    _.each(Consts.Backend.Units.available, function (grp) {
        _.each(grp, function (av) {
            var b = getBaseUnitsStr(av);
            if (b.length == 0) return;
            relatedByBase[b] = relatedByBase[b] || [];
            relatedByBase[b].push(av);
        });
    });

    _.each(relatedByBase, function (ar, key) {
        relatedByBase[key] = _.unique(ar);
    });
};

var findCloseUnits = function (fct) {
    var resultValue = undefined;
    _.each(Consts.Backend.Units.available, function (grp) {
        if (resultValue) return;
        if (_.contains(grp, fct)) {
            resultValue = cloneAsJSON(grp);
        }
    });
    return resultValue || [];
};

var evaluateUnitsFor = function (unitList, values, srcUnit, closeUnits) {
    var unitV = {};
    var minValue = undefined;

    _.each(unitList, function (unit) {
        var isCloseUnit = _.contains(closeUnits, unit);
        var r = -1;
        _.each(values, function (v) {
            var conv = units.convert(v, srcUnit, unit);
            if (!conv.err) {
                var rat = Math.log10(conv.value);
                rat = rat < 0 ? Math.abs(Math.floor(rat)) + 2.5 : Math.ceil(rat);
                if (!isCloseUnit) rat += 5.25;
                rat = Math.floor(rat * 100);
            }
            r = Math.max(r, rat);
        });
        unitV[unit] = r;
        minValue = minValue === undefined ? r : Math.min(r, minValue);
    });

    return {
        units: unitV,
        min: minValue,
    };
};

var units = {
    convert: function (value, source, dest) {
        if (dest == source) return { value: value, err: false };
        var src = getBaseUnits(source);
        var dst = getBaseUnits(dest);
        var isResult = false;
        var result;

        _.each(src, function (rsrc) {
            _.each(dst, function (rdst) {
                if (matchUnitRecalc(rsrc, rdst)) {
                    var newValue = (rsrc.k * value) / rdst.k;
                    if (isResult && newValue != result) {
                        return { value: 0, err: true };
                    }
                    result = newValue;
                    isResult = true;
                }
            });
        });

        if (result === undefined) return { value: 0, err: true };

        return { value: result, err: false };
    },
    getAvailable: function (unit) {
        var myBase = getBaseUnitsStr(unit);
        // unknown unit? do nothing
        if (!myBase || !myBase.length) {
            return [unit];
        }

        buidRelatedMap();
        var r = relatedByBase[myBase] || [];
        r.push(unit);
        return _.sortBy(_.unique(r), function (x) {
            return x;
        });
    },
    fitUnit: function (values, srcUnit) {
        var availUnits = units.getAvailable(srcUnit);
        var val = selectWhere(
            values,
            function (x) {
                return x != 0;
            },
            function (x) {
                return Math.abs(x);
            }
        );
        if (!val.length) return srcUnit;

        var closeUnits = findCloseUnits(srcUnit);
        var unitV = evaluateUnitsFor(availUnits, val, srcUnit, closeUnits);
        var selected = selectWhere(availUnits, function (x) {
            return unitV.units[x] == unitV.min;
        });

        switch (selected.length) {
            case 0:
                return srcUnit;
            case 1:
                return selected[0];
            default:
                return selectByPriority(selected);
        }
    },
};

module.exports = units;
